import { useEffect, useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { useAuth } from "@/hooks/use-auth";

/**
 * Resolves the Convex user document for the currently authenticated Replit
 * user, syncing it on first load. Mirrors the pattern used across the app
 * (Settings, Dashboard) but centralised so team pages can reuse it.
 */
export function useConvexUser() {
  const { user, isLoading: authLoading } = useAuth();
  const [userSynced, setUserSynced] = useState(false);
  const getOrCreateUser = useMutation(api.users.getOrCreateUser);

  useEffect(() => {
    if (user && !userSynced) {
      getOrCreateUser({
        googleId: user.id,
        email: user.email || "",
        name: user.firstName
          ? `${user.firstName} ${user.lastName || ""}`.trim()
          : undefined,
        profileImageUrl: user.profileImageUrl || undefined,
      })
        .then(() => setUserSynced(true))
        .catch((err) =>
          console.error("Failed to sync user with Convex:", err),
        );
    }
  }, [user, userSynced, getOrCreateUser]);

  const convexUser = useQuery(
    api.users.getCurrentUser,
    user && userSynced ? { googleId: user.id } : "skip",
  );

  return {
    user,
    authLoading,
    userSynced,
    convexUser,
    userId: convexUser?._id ?? null,
  };
}
